import React from 'react';

import ButtonGuidelines from './ButtonGuidelines';
import ChipGuidelines from './ChipGuidelines';
import ComponentGuidelines from './ComponentGuidelines';
import DropdownGuidelines from './DropdownGuidelines';
import FieldInputGuidelines from './FieldInputGuidelines';
import FilterFormGuidelines from './FilterFormGuidelines';
import HeaderGuidelines from './HeaderGuidelines';
import SelectInputGuidelines from './SelectInputGuidelines';
import ToastGuidelines from './ToastGuidelines';

export default function Guidelines({component}: {component: string}): JSX.Element {
  switch (component) {
    case 'buttons':
      return <ButtonGuidelines />;
    case 'chips':
      return <ChipGuidelines />;
    case 'dropdowns':
      return <DropdownGuidelines />;
    case 'headers':
      return <HeaderGuidelines />;
    case 'field-inputs':
      return <FieldInputGuidelines />;
    case 'select-inputs':
      return <SelectInputGuidelines />;
    case 'filter-forms':
      return <FilterFormGuidelines />;
    case 'toasts':
      return <ToastGuidelines />;
    default:
      return <ComponentGuidelines />;
  }
}
